import React from "react";
import Index from "../views/dashboard/index";
import DualSidebarNav from "../components/partials/dashboard/SidebarStyle/dual-sidebar";
import DualSidebarNavigation from "../components/partials/dashboard/SidebarStyle/dual-admin-sidebar";
import LicenseManagment from "../components/LicenceManagmentCompo/licenseManagmentPage";
// import Default from "../layouts/dashboard/default"; // DELETED
import { pagePaths } from "../../src/services/constant";
// main dual bar nav components:
import RoleTable from "../components/RoleManagementCompo/roleManagementPage";
import UsersTable from "../components/UserManagementCompo/userManagementTable";
import GroupDetailsPage from "../../src/components/GroupsManagentComponent/GroupDetails.js";
import DepartmentTable from "../components/DepartmentManagementCompo/departmentManagementPage";
import GroupsTable from "../../src/components/GroupsManagentComponent/GroupsTable.js";
import ServicesTable from "../components/ServicesManagementCompo/servicesManagementPage";
import SitesTable from "../components/OrganisationUsersModules/sitesTable";
import OrganizationLevelTable from "../components/OrganisationUsersModules/organization-level-table";
import RegionTable from "../components/OrganisationUsersModules/regionTable";
// import UserAdd from "../views/dashboard/app/user-add"; // DELETED

//library service components:
import LibraryTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-table";
import LibraryDetailsPage from "../components/OrganisationUsersModules/LibraryManagementCompo/library-detail-page";
import LibraryBookDetails from "../components/OrganisationUsersModules/LibraryManagementCompo/a-library-book-details";
import LibraryBookOrderTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-book-order-table";
import LibraryEbooksTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-ebook-table";
import LibraryBarCodeManagementTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-barcode-management-table";
import LibraryBookTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-book-table";
import LibraryAuthorTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-author-table";
import LibraryPublicationTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-publication-table";
import LibraryBookIssueTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-book-issue-table";
import LibraryPanelty from "../components/OrganisationUsersModules/LibraryManagementCompo/library-book-penalty-table";
import LibraryBookCategoryTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-book-catagory-table";
import LibraryUsersTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-users-table";
import LibraryBookRequestTable from "../components/OrganisationUsersModules/LibraryManagementCompo/library-book-request-table";
import CoursesTable from "../components/Academics/courseTable";

import ClassesTabel from "../components/Academics/classesTabel";
import DivisionsTable from "../components/Academics/DivisionTable";
import ClassDetailsPage from "../components/Academics/ClassesDetailsPage";
import LecturesTable from "../components/OrganisationUsersModules/AcademinServiceCompo/lectures-table";
import TimeSlotTable from "../components/OrganisationUsersModules/AcademinServiceCompo/timeslot-table";
import AssignmentTable from "../components/OrganisationUsersModules/AcademinServiceCompo/assigment-table";
import HomeworkTable from "../components/OrganisationUsersModules/AcademinServiceCompo/homework-table";
import SubjectsTable from "../components/Academics/subjectTable";
import TutorTable from "../components/Academics/TutorTable";

import ExaminationScoreTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/examination-score-table";
import SubjectExaminationTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/subject-examination-table";
import PreviousPaperListTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/previous-paper-list-table";
import ExaminationResultListTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/examination-result-list-table";
import SubjectExaminationListTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/subject-examination-list-table";
import SubjectEvaluationListTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/subject-evaluation-list-table";
import ExaminationPolicyListTable from "../components/OrganisationUsersModules/ExaminationServiceCompo/examination-policy-list-table";
import TemplateRequestList from "../components/OrganisationUsersModules/ExaminationServiceCompo/template-request-list-table";
import ParkingListTable from "../components/OrganisationUsersModules/ParkingServiceCompo/parking-list-table";
import ParkingSectionListTable from "../components/OrganisationUsersModules/ParkingServiceCompo/parking-section-list-table";
import UserParkingListTable from "../components/OrganisationUsersModules/ParkingServiceCompo/user-parking-list-table";
import UserSubscriptionListTable from "../components/OrganisationUsersModules/ParkingServiceCompo/user-subscription-list-table";
import SubscriptionLogsListTable from "../components/OrganisationUsersModules/ParkingServiceCompo/subscription-logs-list-table";
import AddDepartmentForm from "../components/FormComponents/AddDepartment";
// hostel service components:
import HostelFacilitiesTable from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-facilities-table";
import HostelTable from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-table";
import RoomsTable from "../components/OrganisationUsersModules/HostelServiceCompo/rooms-table";
import HostelUsersTable from "../components/OrganisationUsersModules/HostelServiceCompo/users-table";
import HostelDetailsPage from "../components/OrganisationUsersModules/HostelServiceCompo/a-hostel-details";
import StaffsTable from "../components/OrganisationUsersModules/HostelServiceCompo/staffs-table";
import MessTable from "../components/OrganisationUsersModules/HostelServiceCompo/mess-table";
import SundayMealTable from "../components/OrganisationUsersModules/HostelServiceCompo/sunday-meal-table";
import BreakfastMealItemTable from "../components/OrganisationUsersModules/HostelServiceCompo/breakfast-meal-item-table";
import ComplaintsTable from "../components/OrganisationUsersModules/HostelServiceCompo/complaints-table";
import AddRoomForm from "../components/OrganisationUsersModules/HostelServiceCompo/add-room-to-hostel";
import HostelFoodMenuTable from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-default-food-menu-table";
import RoomTypesTable from "../components/OrganisationUsersModules/HostelServiceCompo/room-type-table";
import RoomDetailPage from "../components/OrganisationUsersModules/HostelServiceCompo/a-room-details";
import HostelApplicationDetailsPage from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-application-detail";
import HostelFoodMenuDetails from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-food-menu-details";
import HostelMenuMealListTable from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-menu-meal-table";
import GuestTable from "../components/OrganisationUsersModules/HostelServiceCompo/guest-table";
import HostelMenuMealItemsListTable from "../components/OrganisationUsersModules/HostelServiceCompo/hostel-menu-meal-items-table";

//canteen service components:
import CanteenTable from "../components/OrganisationUsersModules/CanteenServiceCompo/canteen-table";
import ProductsTable from "../components/OrganisationUsersModules/CanteenServiceCompo/products-table";
import SuppliersTable from "../components/OrganisationUsersModules/CanteenServiceCompo/suppliers-table";
import OrdersTable from "../components/OrganisationUsersModules/CanteenServiceCompo/orders-table";
import CouponsTable from "../components/OrganisationUsersModules/CanteenServiceCompo/coupons-table";
import PaymentTable from "../components/OrganisationUsersModules/CanteenServiceCompo/payment-table";
import CanteenStaffsTable from "../components/OrganisationUsersModules/CanteenServiceCompo/canteen-staffs-table";

//transport service components:
import TransportVehicleTable from "../components/OrganisationUsersModules/TransportManagementCompo/transport-vehicle-table";
import TransportDetailsPage from "../components/OrganisationUsersModules/TransportManagementCompo/transport-detail-page";
import TransportRouteTable from "../components/OrganisationUsersModules/TransportManagementCompo/transport-route-table";
import TransportStopTable from "../components/OrganisationUsersModules/TransportManagementCompo/transport-stop-table";
import TransportDriverTable from "../components/OrganisationUsersModules/TransportManagementCompo/transport-driver-table";
import TransportMaintenanceTable from "../components/OrganisationUsersModules/TransportManagementCompo/transport-maintenance-table";
import TransportBookingTable from "../components/OrganisationUsersModules/TransportManagementCompo/transport-booking-table";

// library forms:
import BookForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-book";
import AddAuthorForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-author-form";
import AddPublicationForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-publication-form";
import AddBookIssueForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-book-isssue-form";
import AddBookPenaltyForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-book-penalty-form";
import AddBookCategoryForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-book-category-form";
import AddLibraryBookRequestForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-book-request-form";
import AddUsersForm from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-user-form";
import AddLibraryBookOrder from "../components/OrganisationUsersModules/LibraryManagementCompo/library-forms/add-library-order-form";

//USER
import UserDetails from "../components/UserManagementCompo/viewUserDetails";
import DepartmentDetailsPage from "../components/DepartmentManagementCompo/departmentDetails.js";
import RolesDetailsPage from "../components/RoleManagementCompo/roleDetailsPage.js";
// stay here man!
import { Navigate } from "react-router-dom";
import AddUserForm from "../../src/components/FormComponents/AddUserForm";
import AddSiteForm from "../../src/components/FormComponents/AddSite";
import ErrorPage from "../../src/views/dashboard/widget/ErrorPage.js";
import PageNotFound from "../../src/views/dashboard/widget/PageNotFound.js";

import OnBoarding from "../../src/views/dashboard/onboarding/onBoarding.js";
import { getLCP } from "web-vitals";
import { getLocalStorageData } from "../services/axiosComponent";
import {
  PrivateRoute,
  CheckUserTypeRoute,
  CheckIfUserIsOnBoarded,
} from "../services/protectedRoutes";

//accadmic
import TutorProfilePage from "../components/Academics/TutorProfilePage";
import SubjectDetailsPage from "../components/Academics/subjectDetailsPage";
import DivisionSectionTable from "../components/Academics/DivisionSectionTable";
import DivisionSectionDetails from "../components/Academics/DivisionSectionDetails";
import DivisionSectionScheduleView from "../components/Academics/DivisionSectionScheduleView";
import TutorAssignmentTable from "../components/Academics/TutorAssignmentList";
import TutorHomeWorkTable from "../components/Academics/TutorHomeWorkList";
import StudentsTable from "../components/Academics/StudentsTable";
import TutorAssignmentDetailsPage from "../components/Academics/TutorAssignmentDetails";
import TutorHomeWorkDetailsPage from "../components/Academics/HomeworkDetailsPage";
import AcademicYearTable from "../components/Academics/AcademicYearsTable.js";

import FormsIndex from "../components/Forms/index.js";
import AllFromsTable from "../components/Forms/AllFroms/FormsTable.js";
import FormDetailsPage from "../components/Forms/response/viewFrom";
import FormSubmissionPage from "../components/Forms/FormSubmissionPage";
import FormPreview from "../components/Forms/formPreview";
import ExamBuilderIndex from "../components/Examinations/TepmpateEditor/QuestionPaperBbuilder.js";

//Examination service components:
import ExaminationTemplatesTable from "../components/Examinations/Examination/TemplatesTable.js";
import ExaminationTemplateDetailsPage from "../components/Examinations/Examination/TemplateDetailsPage.js";
import QuestionPaperBuilder from "../components/Examinations/TepmpateEditor/QuestionPaperBbuilder.js";
import QuestionPaperPreview from "../components/Examinations/Examination/QuestionPaperPreView.js";
import ExaminationSeriesList from "../components/Examinations/Examination/series/seriesTable.js";
import ExaminationSeriesDetailsPage from "../components/Examinations/Examination/series/ExaminationSeriesDetailsPage.js";
export const UsersRouter = [
  {
    path: "organisation",
    element: (
      <PrivateRoute>
        <CheckUserTypeRoute>
          <DualSidebarNavigation />
        </CheckUserTypeRoute>
        {/* <DualSidebarNav/> */}
      </PrivateRoute>
    ),
    // just for deploying the project
    children: [
      {
        path: "users/user-add",
        element: <AddUserForm />,
      },

      // main dual side bar nav routes here!
      {
        path: "users/roles",
        element: <RoleTable />,
      },
      {
        path: `users/roles/view-role/:id`,
        element: <RolesDetailsPage />,
      },

      {
        path: "organization-levels",
        element: <OrganizationLevelTable />,
      },
      {
        path: "regions",
        element: <RegionTable />,
      },
      {
        path: "users/users-list",
        element: <UsersTable />,
      },
      {
        path: "users/users-list/view-user/:id",
        element: <UserDetails />,
      },

      {
        path: "users/departments",
        element: <DepartmentTable />,
      },

      {
        path: "users/departments/view-department/:id",
        element: <DepartmentDetailsPage />,
      },
      {
        path: "users/add-department",
        element: <AddDepartmentForm />,
      },

      {
        path: "dashboard",
        element: <Index />,
      },

      {
        path: "license",
        element: <LicenseManagment />,
      },

      {
        path: "users/groups",
        element: <GroupsTable />,
      },
      {
        path: `users/groups/${pagePaths["Groups"].viewPage.label}/:id`,
        element: <GroupDetailsPage />,
      },

      {
        path: "services",
        element: <ServicesTable />,
      },

      {
        path: "sites",
        element: <SitesTable />,
      },
      {
        path: "add-sites",
        element: <AddSiteForm />,
      },
      // other routes here!

      // library service routes here!
      {
        path: "library/library-list",
        element: <LibraryTable />,
      },
      {
        path: `library/library-list/${pagePaths["Library"].viewPage.label}/:id`,
        element: <LibraryDetailsPage />,
      },

      {
        path: `library/:id/${pagePaths["Library"].viewPage.label}/books`,
        element: <LibraryBookTable />,
      },
      {
        path: `library/:id/${pagePaths["Library"].viewPage.label}/books/${pagePaths["Books"].viewPage.label}/:bookId`,
        element: <LibraryBookDetails />,
      },
      {
        path: "library/add-book",
        element: <BookForm />,
      },
      {
        path: `library/:id/${pagePaths["Library"].viewPage.label}/authors`,
        element: <LibraryAuthorTable />,
      },
      {
        path: "library/add-author",
        element: <AddAuthorForm />,
      },
      {
        path: `library/:id/${pagePaths["Library"].viewPage.label}/publications`,
        element: <LibraryPublicationTable />,
      },
      {
        path: "library/add-publication",
        element: <AddPublicationForm />,
      },
      {
        path: "library/book-issue",
        element: <LibraryBookIssueTable />,
      },
      {
        path: "library/add-book-issue",
        element: <AddBookIssueForm />,
      },
      {
        path: `library/:id/${pagePaths["Library"].viewPage.label}/penalty`,
        element: <LibraryPanelty />,
      },
      {
        path: "library/add-penalty",
        element: <AddBookPenaltyForm />,
      },
      {
        path: `library/:id/${pagePaths["Library"].viewPage.label}/categories`,
        element: <LibraryBookCategoryTable />,
      },
      {
        path: "library/add-book-category",
        element: <AddBookCategoryForm />,
      },
      {
        path: "library/users",
        element: <LibraryUsersTable />,
      },
      {
        path: "library/add-user",
        element: <AddUsersForm />,
      },
      {
        path: "library/book-request",
        element: <LibraryBookRequestTable />,
      },
      {
        path: "library/add-book-request",
        element: <AddLibraryBookRequestForm />,
      },
      {
        path: "library/barcode-management",
        element: <LibraryBarCodeManagementTable />,
      },
      {
        path: "library/ebooks",
        element: <LibraryEbooksTable />,
      },
      {
        path: "library/book-order",
        element: <LibraryBookOrderTable />,
      },
      {
        path: "library/add-book-order",
        element: <AddLibraryBookOrder />,
      },
      // for Accademics!
      {
        path: "academic/student",
        element: <StudentsTable />,
      },
      {
        path: "academic/academic-years",
        element: <AcademicYearTable />,
      },

      {
        path: "academic/tutor-homework",
        element: <TutorHomeWorkTable />,
      },
      {
        path: "academic/tutor-homework/view-tutor-homework/:id",
        element: <TutorHomeWorkDetailsPage />,
      },
      {
        path: "academic/tutor-assignment",
        element: <TutorAssignmentTable />,
      },
      {
        path: "academic/tutor-assignment/view-tutor-assignment/:id",
        element: <TutorAssignmentDetailsPage />,
      },
      {
        path: "academic/division-sections",
        element: <DivisionSectionTable />,
      },
      {
        path: "academic/division-sections/view-division-section/:id",
        element: <DivisionSectionDetails />,
      },
      {
        path: "academic/division-sections/view-division-section/:id/view-division-section-schedule/:scheduleId",
        element: <DivisionSectionScheduleView />,
      },

      {
        path: "academic/course",
        element: <CoursesTable />,
      },
      {
        path: "academic/classes",
        element: <ClassesTabel />,
      },

      {
        path: "academic/classes/view-class/:id",
        element: <ClassDetailsPage />,
      },
      {
        path: "academic/divisions",
        element: <DivisionsTable />,
      },
      {
        path: "academic/lectures",
        element: <LecturesTable />,
      },
      {
        path: "academic/timeslot",
        element: <TimeSlotTable />,
      },
      {
        path: "academic/assignment",
        element: <AssignmentTable />,
      },
      {
        path: "academic/homework",
        element: <HomeworkTable />,
      },
      {
        path: "academic/subject",
        element: <SubjectsTable />,
      },
      {
        path: "academic/subject/view-subject/:id",
        element: <SubjectDetailsPage />,
      },
      {
        path: "academic/tutor",
        element: <TutorTable />,
      },
      {
        path: "academic/tutor/view-tutor/:id",
        element: <TutorProfilePage />,
      },

      // examination service routes here~

      {
        path: "examination/templates",
        element: <ExaminationTemplatesTable />,
      },
      {
        path: "examination/series",
        element: <ExaminationSeriesList />,
      },
      {
        path:"examination/series/view-series/:id",
        element: <ExaminationSeriesDetailsPage />,
      },


      {
        path: "examination/templates/view-template/:id",
        element: <ExaminationTemplateDetailsPage />,
      },

      // parking service routes here~
      {
        path: "parking/list",
        element: <ParkingListTable />,
      },
      {
        path: "parking/section-list",
        element: <ParkingSectionListTable />,
      },
      {
        path: "parking/user-list",
        element: <UserParkingListTable />,
      },
      {
        path: "parking/user-subscription",
        element: <UserSubscriptionListTable />,
      },
      {
        path: "parking/subscription-logs",
        element: <SubscriptionLogsListTable />,
      },

      // hostels services
      {
        path: "hostel/hostel-list",
        element: <HostelTable />,
      },
      {
        path: "users/user-add",
        element: <AddUserForm />,
      },

      {
        path: `hostel/hostel-list/${pagePaths["Hostel"].viewPage.label}/:id`,
        element: <HostelDetailsPage />,
      },

      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/rooms`,
        element: <RoomsTable />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/rooms/${pagePaths["Rooms"].viewPage.label}/:roomId`,
        element: <RoomDetailPage />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/${pagePaths["Rooms"].viewPage.label}/:roomId`,
        element: <RoomDetailPage />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/room-types`,
        element: <RoomTypesTable />,
      },
      {
        path: "hostel/add-room",
        element: <AddRoomForm />,
      },
      {
        path: "hostel/users",
        element: <HostelUsersTable />,
      },
      {
        path: "hostel/staffs",
        element: <StaffsTable />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/guests`,
        element: <GuestTable />,
      },
      {
        path: "hostel/mess",
        element: <MessTable />,
      },
      {
        path: "hostel/sunday-meal",
        element: <SundayMealTable />,
      },
      {
        path: "hostel/breakfast-meal",
        element: <BreakfastMealItemTable />,
      },

      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/complains`,
        element: <ComplaintsTable />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/food-menu`,
        element: <HostelFoodMenuDetails />,
      },
      {
        path: "hostel/facilities/:id",
        element: <HostelFacilitiesTable />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/application-detail`,
        element: <HostelApplicationDetailsPage />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/food-menu/meals/:foodMenuId`,
        element: <HostelMenuMealListTable />,
      },
      {
        path: `hostel/:id/${pagePaths["Hostel"].viewPage.label}/food-menu/meals/:foodMenuId/${pagePaths["Meals"].viewPage.label}/:mealId`,
        element: <HostelMenuMealItemsListTable />,
      },

      {
        path: "canteen/canteen-list",
        element: <CanteenTable />,
      },

      {
        path: "canteen/products",
        element: <ProductsTable />,
      },
      {
        path: "canteen/suppliers",
        element: <SuppliersTable />,
      },
      {
        path: "canteen/orders",
        element: <OrdersTable />,
      },
      {
        path: "canteen/coupons",
        element: <CouponsTable />,
      },
      {
        path: "canteen/payment",
        element: <PaymentTable />,
      },
      {
        path: "canteen/staffs",
        element: <CanteenStaffsTable />,
      },

      // transport service routes here!
      {
        path: "transport/vehicles",
        element: <TransportVehicleTable />,
      },
      {
        path: `transport/vehicles/${pagePaths["Transport"].viewPage.label}/:id`,
        element: <TransportDetailsPage />,
      },
      {
        path: `transport/:id/${pagePaths["Transport"].viewPage.label}/routes`,
        element: <TransportRouteTable />,
      },
      {
        path: `transport/:id/${pagePaths["Transport"].viewPage.label}/stops`,
        element: <TransportStopTable />,
      },
      {
        path: `transport/:id/${pagePaths["Transport"].viewPage.label}/drivers`,
        element: <TransportDriverTable />,
      },
      {
        path: `transport/:id/${pagePaths["Transport"].viewPage.label}/maintenance`,
        element: <TransportMaintenanceTable />,
      },
      {
        path: `transport/:id/${pagePaths["Transport"].viewPage.label}/booking`,
        element: <TransportBookingTable />,
      },

      //forms
      {
        path: "forms",
        element: <AllFromsTable />,
      },

      {
        path: "forms/view-form/:id",
        element: <FormDetailsPage />,
      },
    ],
  },
  {
    path: "form/:id",
    element: (
      <PrivateRoute>
        <FormPreview isSubmission={true} />
      </PrivateRoute>
    ),
  },
  {
    path: "examination/template",
    element: <ExamBuilderIndex />,
  },
  {
    path: "examination/templates/edit-template/:id",
    element: <QuestionPaperBuilder />,
  },

  {
    path: "examination/templates/preview-template/:id",
    element: <QuestionPaperPreview />,
  },

  {
    path: "new-form",
    element: <FormsIndex />,
  },
  {
    path: "edit-form/:id",
    element: <FormsIndex />,
  },

  {
    path: "server-down",
    element: <ErrorPage />,
  },

  {
    path: "onBoarding",
    element: (
      <PrivateRoute>
        <CheckIfUserIsOnBoarded>
          <OnBoarding />
        </CheckIfUserIsOnBoarded>
      </PrivateRoute>
    ),
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
];
